export default __webpack_public_path__ + "static/media/tudaskozpont.8d7304f2.svg";